<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="12">
        <CustCategory :custCode="custCode" :disabled="disabled" />
      </el-col>
      <el-col :span="12">
        <CustBrand :custCode="custCode" :disabled="disabled" />
      </el-col>
      <el-col :span="24" class="mt-3">
        <CustDep :custCode="custCode" :disabled="disabled" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CustCategory from '../cust-category'
import CustBrand from '../cust-brand'
import CustDep from '../cust-dep'
export default {
  components: { CustCategory, CustBrand, CustDep },
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    async validate() {
      return true
    },
    async complete() {
      if (!(await this.validate())) return
      return true
    },
  },
}
</script>
